// Query key factory for schedule-related queries
export const scheduleKeys = {
  all: ['schedule'] as const,
  myShifts: (profileId: string, weekStart: string, weekEnd: string) => 
    [...scheduleKeys.all, 'myShifts', profileId, weekStart, weekEnd] as const,
  openShifts: (companyId: string, weekStart: string, weekEnd: string) => 
    [...scheduleKeys.all, 'openShifts', companyId, weekStart, weekEnd] as const,
  // SchedulePlanner-specific keys
  companyShifts: (companyId: string, weekStart: string, weekEnd: string) => 
    [...scheduleKeys.all, 'companyShifts', companyId, weekStart, weekEnd] as const,
  companyProfiles: (companyId: string) => 
    [...scheduleKeys.all, 'companyProfiles', companyId] as const,
  // Swap-related keys (user-specific)
  mySwapRequests: (profileId: string, statusFilter?: string[]) => 
    [...scheduleKeys.all, 'mySwapRequests', profileId, statusFilter] as const,
  swapOffersForMe: (profileId: string, statusFilter?: string[]) => 
    [...scheduleKeys.all, 'swapOffersForMe', profileId, statusFilter] as const,
  eligibleSwapCandidates: (shiftId: string) => 
    [...scheduleKeys.all, 'eligibleSwapCandidates', shiftId] as const,
  // Roster planning keys
  monthlyRoster: (companyId: string, year: number, month: number) =>
    [...scheduleKeys.all, 'monthlyRoster', companyId, year, month] as const,
  shiftCodes: (companyId: string) =>
    [...scheduleKeys.all, 'shiftCodes', companyId] as const,
};
